"use client";

import React from "react";
import { siteConfig } from "@/config/site";
import { trackAffiliateClick } from "@/lib/analytics";

interface CallToActionProps {
  title?: string;
  description?: string;
  buttonText?: string;
  source?: string;
}

export default function CallToAction({
  title = "准备开始使用Wise？",
  description = "注册Wise账户，享受透明汇率和低手续费的国际汇款服务",
  buttonText = "立即注册",
  source = "cta",
}: CallToActionProps) {
  const href = `${siteConfig.links.affiliate}?source=${encodeURIComponent(source)}`;

  return (
    <div data-agent-ignore className="mt-12 rounded-2xl bg-gradient-to-r from-green-600 to-green-700 p-6 text-center text-white sm:p-8">
      <h3 className="text-xl sm:text-2xl font-bold mb-4">{title}</h3>
      <p className="text-base sm:text-lg mb-6 opacity-90">{description}</p>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackAffiliateClick(source)}
        className="inline-flex w-full items-center justify-center rounded-xl bg-white px-8 py-4 text-base font-semibold text-green-700 transition-colors hover:bg-green-50 hover:text-green-800 sm:w-auto sm:py-3"
      >
        {buttonText}
      </a>
    </div>
  );
}
